import { Filter } from 'components/molecules/filters/types';
import { QueryCombinerType } from 'components/organisms/tasks/combiner';
import { DateField } from 'components/organisms/tasks/fields';
import { DateFieldFilterOperationType } from 'components/organisms/tasks/filters/date';
import { TaskField } from 'stores/fields';

export const getCompletedTasksFilter = (
  taskFields: Record<string, TaskField>,
): Filter => ({
  criteria: [taskFields.completedAt as unknown as DateField]
    .filter(Boolean)
    .map((field) => ({
      field,
      type: DateFieldFilterOperationType.IsNotEmpty,
    })),
  type: QueryCombinerType.All,
});
